export const incrementLinksCount = (field: string) => {
  const storageData = localStorage.getItem("links");
  const data = JSON.parse(storageData ?? "{}");
  const newData = { ...data, [field]: (data[field] ?? 0) + 1 };
  localStorage.setItem("links", JSON.stringify(newData));
};
